import React, { useMemo } from 'react'

import { Button, Space } from '@mantine/core'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { Link, useLocation, useParams } from 'react-router-dom'

import { ActivityhubClientActivity } from '@clinic/client'
import { ReportType } from '~/pages/reports/shared/types'
import { historicalEventTelemetry } from '~/telemetry/event-center'
import { formatDateTimeWithTz } from '~/utils/date-time'

import { hasOOMInsight } from '../../shared/utils'

const columns: ColumnsType<ActivityhubClientActivity> = [
  {
    title: 'Event Name',
    dataIndex: 'name',
    key: 'name',
    width: 120,
    render: (_, record) => record.display_name || record.name
  },
  {
    title: 'Status',
    dataIndex: 'payload',
    key: 'status',
    width: 80,
    render: (v) => v.display_status
  },
  {
    title: 'Time',
    dataIndex: 'calibration_time',
    key: 'time',
    width: 200,
    render: (val) => formatDateTimeWithTz(val)
  },
  // {
  //   title: 'Source',
  //   dataIndex: 'source',
  //   key: 'source',
  //   width: 150
  // },
  {
    title: 'Summary',
    dataIndex: 'payload',
    key: 'summary',
    width: 400,
    render: (v) => <div style={{ whiteSpace: 'pre-wrap' }}>{v.summary}</div>
  },
  {
    title: 'EventGroup',
    dataIndex: 'payload',
    key: 'eventgroup',
    width: 100,
    render: (v) =>
      v.context_id == null ? '' : v.display_event_type + '-' + v.context_id
  },
  {
    title: 'Action',
    key: 'action',
    width: 100,
    render: (_, record) => <DetailAction record={record} />
  }
]

const DetailAction = ({ record }: { record: ActivityhubClientActivity }) => {
  const location = useLocation()
  const { orgId, cid } = useParams()
  const detailPath = useMemo(() => {
    if (hasOOMInsight(record)) {
      return `/orgs/${orgId}/clusters/${cid}/report/${ReportType.OOM}/${record.context_id}`
    }
    const pArr = location.pathname.split('/')
    pArr.pop()
    return `${pArr.join('/')}/detail/${record.activity_id}`
  }, [location, record, orgId, cid])
  return (
    <Link
      className='select-none'
      to={detailPath}
      onClick={() =>
        historicalEventTelemetry.clickDetail(
          record.context_id!,
          record.activity_id!
        )
      }
      target='_blank'
    >
      Details
    </Link>
  )
}

interface HistoryTableProps {
  data: ActivityhubClientActivity[]
  loading?: boolean
  partial?: boolean
  loadmore?: (init?: boolean) => void
}

export const HistoryTable: React.FC<HistoryTableProps> = ({
  loading,
  data,
  partial,
  loadmore
}) => {
  return (
    <>
      <Table<ActivityhubClientActivity>
        bordered
        columns={columns}
        dataSource={data}
        size='small'
        pagination={false}
        loading={loading}
      />
      <Space h='md' />
      {!loading && !partial && data.length <= 20 ? (
        <></>
      ) : (
        <Button
          variant='subtle'
          fullWidth
          loading={loading}
          disabled={!partial}
          onClick={() => loadmore?.()}
        >
          {loading ? 'Loading...' : partial ? 'Loadmore' : 'No more data'}
        </Button>
      )}
    </>
  )
}
